import { Link, useLocation, useParams } from "react-router-dom";
import { getArticleById } from "../../pages/use-cases/articlesData";
import "./breadcrumbs.css";
import { useLanguage } from "../../i18n/LanguageContext";

const Breadcrumbs = () => {
  const { tr } = useLanguage();
  const location = useLocation();
  const pathname = location.pathname;
  const { id } = useParams();

  // Don't show breadcrumbs on landing page
  if (pathname === "/") {
    return null;
  }

  // Check if we're on an article detail page
  const isArticleDetail = pathname.startsWith("/use-cases/") && id;
  let article = null;
  if (isArticleDetail) {
    article = getArticleById(id);
  }

  // Map pathname to page name
  const getPageName = (path) => {
    const pageMap = {
      "/about": tr("About", "Tentang"),
      "/portfolio": tr("Portfolio", "Portofolio"),
      "/pricing": tr("Pricing", "Harga"),
      "/use-cases": tr("Use Cases", "Use Case"),
      "/how-we-work": tr("How We Work", "Cara Kerja"),
      "/faq": "FAQ",
      "/permissions-terms-privacy": tr("Permissions & Terms Privacy", "Izin & Ketentuan Privasi"),
      "/policy": tr("Policy", "Kebijakan"),
    };
    return pageMap[path] || tr("Page", "Halaman");
  };

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <div className="breadcrumbs-container">
        <Link to="/" className="breadcrumbs-home">
          {tr("Home", "Beranda")}
        </Link>
        <span className="breadcrumbs-separator">/</span>
        {isArticleDetail && article ? (
          <>
            <Link to="/use-cases" className="breadcrumbs-link">
              {tr("Use Cases", "Use Case")}
            </Link>
            <span className="breadcrumbs-separator">/</span>
            <span className="breadcrumbs-current">{tr(article.title, article.titleId || article.title)}</span>
          </>
        ) : (
          <span className="breadcrumbs-current">{getPageName(pathname)}</span>
        )}
      </div>
    </nav>
  );
};

export default Breadcrumbs;

